<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<h2><a id="page9">THE FIRST FISH I EVER CAUGHT ON A FLY ROD</a></h2><a id="page9">
<p class="start1"></p>
<p class="center"><img alt="image" src="images/p9.jpg"/></p>
<p class="noindent1">was a bluegill when I was 10 years old. I had no idea what I was doing, but somehow that summer afternoon, one of my wild flails got a little Wooly Bugger—one of six flies I owned—just far enough off the bank to get eaten. I was instantly in love with flyfishing, and 22 years later, I’ve come to realize that no matter your skill level, the excitement of a hooking a fish on fly mirrors the first time again and again.</p>
<p class="indent">I believe that’s because flyfishing makes you think. Every aspect—from where you stand, to how your fly lands, to how you’ll fight a fish—requires calculation. Is it more work than casting and retrieving a lure? Absolutely, but it’s this challenge that makes every fish caught on fly a little sweeter.</p>
<p class="indent">What I don’t believe is that flyfishing is superior to any other form of the sport. To me, a fly rod is another tool in my arsenal, and just as a good golfer needs to know how to putt and drive, all anglers should have a basic understanding of flyfishing. Fish long enough and I guarantee a scenario will arise when a well-presented fly will hook a fish faster than any lure or bait. And whether you are a life-long flycaster or thinking about buying your first outfit, I promise this book will ready you for any situation you face with a fly rod in hand.</p>
<p class="start2"></p>
<p class="noindent"><span class="bold">JOE CERMELE</span></p>
<p class="noindent">Fishing Editor, <em class="italic">Field &amp; Stream</em></p>
</a></div><a id="page9">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cap00b.vue?17813477